import React,{ useState, useEffect, Fragment } from 'react'
import AllVerification from '../../component/AllVerification';
import axios from 'axios'
import { Box } from '@chakra-ui/react';
import { Auth } from '../../component/Auth';
function CustomerVerified() {
    const [tData, setTData] = useState([]);
    const [isLoading, setIsLoading] = useState({loading: true, error: false})

  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order?status=ORDER_VERIFIED`,
      headers: {
      'Authorization': Auth()
       }
    };
    
    axios.request(config)
    .then((response) => {
      setTData(response.data);
      setIsLoading({loading: false, error: false})

    })
    .catch((error) => {
      console.log('error-getting-verified-order');
      setIsLoading({loading: false, error: true})

    });
    
  },[])

  return (
    <Fragment>
      <Box p={5} flex="1" w={'100%'}>
    <AllVerification 
      title={'Customer Verified'}
      head={["Order", "Date", "Customer Name", "Profession", "Customer Status", "Verification Status",""]}
      data={tData}
      isLoading={isLoading}
      />
     </Box>
    </Fragment>
  )
}

export default CustomerVerified